import React, { useContext, useEffect } from "react";
import { quoteContext } from "../../context/quotesContext";
import { CustomSelect } from "../CustomSelect";
import { Button } from "../Button";
import rule from "../../../public/assets/iconRule.svg";
import paid from "../../../public/assets/icon/Paid.svg";
import { SummarOrderMobile } from "../SummarOrderMobile";
import { useTranslation } from "react-i18next";

const DimensionSummary = () => {
  const {
    dimensions,
    value,
    weight,
    setCurrentStep,
    dimensionsType,
    weightType,
    createShipmentResponse,
    selectedProvider,
    setSelectedProvider,
    setCurrentSubStep,
  } = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  const dimensionsTypeText = () => {
    return dimensionsType.id === 1 ? "cm" : "inc";
  };

  const weightTypeText = () => {
    return weightType.id === 1 ? "Lb" : "Kg";
  };

  const shipmentOptions = () => {
    const cheapestTotal = createShipmentResponse.rate_options.reduce(
      (min, item) => Math.min(min, Number(item.total)),
      Infinity
    );
    const rates = createShipmentResponse.rate_options.map((item) => ({
      id: item.shipment_id_provider,
      label: `${item.provider} - ${item.estimated_days} ${
        Number(item.estimated_days) > 0 ? t("days") : t("day")
      } - ${t("cost")}: $${item.total} USD${
        Number(item.total) === cheapestTotal ? ` (${t("cheapest")})` : ""
      }`,
      ...item,
    }));
    if (selectedProvider && selectedProvider.label === "" && rates) {
      setSelectedProvider(rates[0]);
    }
    return rates;
  };

  return (
      <>
        <div className="first-step-container-resume">
          <div className="content-resume">
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('large')}</span>
              <span className="value">
              {dimensions.long} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('high')}</span>
              <span className="value">
              {dimensions.height} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label"> {t('width')}</span>
              <span className="value">
              {dimensions.broad} {dimensionsTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={rule}/>
              <span className="label">{t('weight')}</span>
              <span className="value">
              {weight} {weightTypeText()}
            </span>
            </div>
            <div className="item">
              <img src={paid}/>
              <span className="label">{t('declared_value')}</span>
              <span className="value">{value} USD</span>
            </div>
          </div>
          <a onClick={() => setCurrentStep(1)} className="link-blue">
            {t('edit_measures')}
          </a>
        </div>

        <div className="usa-select-input-provider">
          <h3>
            {t('delivery_options')}
          </h3>
          <CustomSelect
              className="selct-with-border"
              value={selectedProvider}
              options={shipmentOptions()}
              onSelect={setSelectedProvider}
          ></CustomSelect>
        </div>

        <div className="col-details-mobile">
          <SummarOrderMobile></SummarOrderMobile>
        </div>
        <div className="actions-container">
          <a onClick={() => setCurrentSubStep(1)} className="link-blue">
            {t('return')}
          </a>
          <Button onClick={() => setCurrentSubStep(3)}> {t('continue')}</Button>
        </div>
      </>
  );
};

export {DimensionSummary};
